import { useState } from "react";
import { useTranslation } from "react-i18next";
import Timestamp from "../components/Timestamp";
import ProjectCard from "../components/ProjectCard";
import projects from "../data/projects.json";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

const ProjectsSection = () => {
    const { t } = useTranslation();
    const [showAll, setShowAll] = useState(false);
    const [filter, setFilter] = useState('all');

    const handleFilterChange = (event, newFilter) => {
      if (newFilter !== null) {
        setFilter(newFilter);
      }
    };

    const filteredProjects = projects.filter(project => {
      switch(filter) {
        case 'live':
          return project.isLive;
        case 'ongoing':
          return project.isOngoing;
        default:
          return true;
      }
    });

    const displayedProjects = showAll ? filteredProjects : filteredProjects.slice(0, 6);

    return (
      <section className="flex relative justify-center px-4 py-8 bg-grid-lines bg-grid-pattern sm:px-8 scroll-mt-16" id="projects">
        <div className="flex flex-col w-full max-w-6xl h-full">
          {/* Title and Filter Section */}
          <div className="flex flex-col mb-6 sm:flex-row sm:justify-between sm:items-start">
            <div>
              <h2 className="text-3xl font-bold sm:text-4xl">{t("recent projects")}</h2>
              <p className="mt-2 max-w-xl text-sm text-secondary">
                {t("projects_disclaimer")}
              </p>
              <Timestamp className="mt-2" />
            </div>
            
            <ToggleButtonGroup
              value={filter}
              exclusive
              onChange={handleFilterChange}
              aria-label="project filter"
              className="mt-4 sm:mt-0"
              sx={{
                '& .MuiToggleButton-root': {
                  color: 'var(--color-primary)',
                  borderColor: 'var(--color-border-)',
                  textTransform: 'none',
                  '&.Mui-selected': {
                    backgroundColor: 'var(--color-background)',
                    fontWeight: 'bold',
                    borderColor: 'var(--color-primary)',
                    color: 'var(--color-primary)',
                  },
                  '&:hover': {
                    backgroundColor: 'var(--color-blue-100)',
                  },
                },
              }}
            >
              <ToggleButton value="all">
                {t("all_projects")}
              </ToggleButton>
              <ToggleButton value="live">
                {t("live_projects")}
              </ToggleButton>
              <ToggleButton value="ongoing">
                {t("ongoing_projects")}
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          {/* Project Cards */}
          <div className="flex flex-wrap gap-6 justify-center">
            {displayedProjects.map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>

          {/* Show More Button */}
          {filteredProjects.length > 6 && (
            <div className="flex justify-center mt-8">
              <button 
                onClick={() => setShowAll(!showAll)}
                className="px-6 py-2 rounded-full border transition duration-200 bg-background text-primary border-secondary hover:bg-gray-100"
              >
                {showAll ? t("show_less") : t("show_more")}
              </button>
            </div>
          )}
        </div>
      </section>
    );
};

export default ProjectsSection;
